module.exports = __webpack_public_path__ + "img/product.48c9f86a.png";